import React from "react";

const QUOTES = [
  {
    quote:
      "Shirataki used to mean a special grocery trip. Oryvita on subscription means it’s a Tuesday dinner. Quiet game-changer.",
    name: "Lina P.",
    role: "CrossFit coach · Abu Dhabi",
  },
  {
    quote:
      "Finally a rice alternative I don’t have to bring back in my suitcase from Japan. The 1 kg pack lasts our family a fortnight.",
    name: "Ahmed K.",
    role: "Triathlete · Dubai",
  },
  {
    quote:
      "Clean ingredients, honest texture, ready in minutes. Genuinely curated — you can tell the people behind this actually cook with what they sell.",
    name: "Marco D.",
    role: "Cyclist · Al Qudra",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-surfacealt"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-3">
            <div className="overline text-terracotta mb-3">Field Notes</div>
            <h2 className="font-display font-black text-3xl md:text-4xl text-ink leading-tight tracking-tight">
              What our
              <br />
              <span className="font-wordmark italic font-semibold">customers</span>
              <br />
              say.
            </h2>
          </div>
          <div className="md:col-span-9 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {QUOTES.map((q, i) => (
              <figure
                key={i}
                data-testid="testimonial-quote"
                className="flex flex-col justify-between border-t border-ink/20 pt-6"
              >
                <blockquote className="font-wordmark italic text-ink text-xl md:text-2xl leading-snug">
                  “{q.quote}”
                </blockquote>
                <figcaption className="mt-8">
                  <div className="font-display font-bold text-ink text-sm">
                    {q.name}
                  </div>
                  <div className="overline text-inkmute mt-1">{q.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
